const th = {
    common: {
        history: "รุ่นประวัติศาสตร์"
    }
};
export default th;



// WEBPACK FOOTER //
// ./src/i18n/langs/th.js